import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Image'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z"
          fill="#FFD6B0"
        />
        <path
          d="M33.5 13.75V33.4375C33.5 33.9553 33.0803 34.375 32.5625 34.375H14.75M37.25 17.5V37.1875C37.25 37.7053 36.8303 38.125 36.3125 38.125H18.5M29.75 25H11M16.625 25L21.8162 17.585C22.1466 17.1132 22.6754 16.8195 23.2505 16.7882C23.8255 16.757 24.383 16.9918 24.7625 17.425L29.75 23.125M11.75 30.625H29C29.4142 30.625 29.75 30.2892 29.75 29.875V10.75C29.75 10.3358 29.4142 10 29 10H11.75C11.3358 10 11 10.3358 11 10.75V29.875C11 30.2892 11.3358 30.625 11.75 30.625ZM15.6875 14.2188C15.9464 14.2188 16.1562 14.4286 16.1562 14.6875C16.1562 14.9464 15.9464 15.1562 15.6875 15.1562C15.4286 15.1562 15.2188 14.9464 15.2188 14.6875C15.2188 14.4286 15.4286 14.2188 15.6875 14.2188Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
